module.exports = __webpack_public_path__ + "../static/img/cloud_devices.32041f19.png";